import { render, staticRenderFns } from "./hot-topic-details.vue?vue&type=template&id=e0bba75a&scoped=true&"
import script from "./hot-topic-details.vue?vue&type=script&lang=js&"
export * from "./hot-topic-details.vue?vue&type=script&lang=js&"
import style0 from "./hot-topic-details.vue?vue&type=style&index=0&id=e0bba75a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bba75a",
  null
  
)

export default component.exports